const { every, filter, some } = require('lodash');

const {
    PLAN_TYPE,
    SUBSCRIBER_TYPE,
} = require('../delivery-saver.constants');

class DeliverySaverFeature {
    constructor(name, includedInMidweek, includedInAnyDay) {
        this.name = name;
        this.includedInMidweek = includedInMidweek;
        this.includedInAnyDay = includedInAnyDay;
    }
}

class DeliverySaverEligibility {
    constructor(name, requiredForMidweek, requiredForAnyDay) {
        this.name = name;
        this.requiredForMidweek = requiredForMidweek;
        this.requiredForAnyDay = requiredForAnyDay;
    }
}

class DeliverySaverPlanTypesController {
    constructor($state, settings) {
        this.$state = $state;
        this.settings = settings;
        this.PLAN_TYPE = PLAN_TYPE;
    }

    $onInit() {
        this.updatePlanGroupsAndFeatures();
    }

    $onChanges() {
        this.updatePlanGroupsAndFeatures();
    }

    updatePlanGroupsAndFeatures() {
        this.plansBySubscriberType = this.filterByBySubscriberType(this.subscriberType);

        const midweekPlans = filter(this.plansBySubscriberType, p => p.IsMidweek);
        const anyDayPlans = filter(this.plansBySubscriberType, p => p.IsAnyDay);
        this.planGroups = [midweekPlans, anyDayPlans];
        this.features = this.createFeatureList();
        this.eligibilities = this.createEligibilities();
    }

    selectPlanType(planType) {
        const subscriberType = this.subscriberType;
        this.$state.go('shop.deliveryunlimited.paymentsetup', { subscriberType, planType });
    }

    get buttonText() {
        return this.isFreeTrialAvailable ? 'Start my free trial' : 'Subscribe';
    }

    createEligibilities() {
        const eligibilities = [];

        if (this.containsSeniorPlans()) {
            const person60AndOver = new DeliverySaverEligibility(
                this.settings.deliverySaverEligibilities.person60AndOver,
                true,
                true,
            );
            eligibilities.push(person60AndOver);
        }

        return eligibilities;
    }

    createFeatureList() {
        const features = [];

        // Ensure that free trials are available and the same length for all plans before listing it as a feature
        const freeTrialDays = this.plansBySubscriberType && this.plansBySubscriberType[0] && this.plansBySubscriberType[0].FreeTrialDays;
        if (freeTrialDays) {
            this.isFreeTrialAvailable = every(this.plansBySubscriberType, plan => plan.FreeTrialDays === freeTrialDays);

            if (this.isFreeTrialAvailable) {
                const freeTrialMessage = this.settings.deliverySaverFeatures.freeTrial.replace('{freeTrialDays}', freeTrialDays);
                features.push(new DeliverySaverFeature(freeTrialMessage, true, true));
            }
        }

        // Ensure that minimumOrderAmount is the same for all plans before mentioning the value
        const minimumOrderAmount = this.plansBySubscriberType && this.plansBySubscriberType[0] && this.plansBySubscriberType[0].Metadata && this.plansBySubscriberType[0].Metadata.MinimumOrderAmount;
        let minimumOrderAmountMessage = 'Minimum spend required';
        if (minimumOrderAmount != null && minimumOrderAmount >= 0) {
            const isSameMinimumOrderAmount = every(this.plansBySubscriberType, plan => plan.Metadata && plan.Metadata.MinimumOrderAmount === minimumOrderAmount);

            if (isSameMinimumOrderAmount) {
                minimumOrderAmountMessage = this.settings.deliverySaverFeatures.minimumOrderAmount
                    .replace('{minimumOrderAmount}', minimumOrderAmount);
            }
        }

        features.push(
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.handPicked, true, true),
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.coversPackingCosts, true, true),
            new DeliverySaverFeature(minimumOrderAmountMessage, true, true),
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.cancelAnytime, true, true),
        );

        if (this.containsB2bPlans()) {
            features.push(new DeliverySaverFeature(this.settings.deliverySaverFeatures.deliveryAddressPerAccount, true, true));
        }

        features.push(
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.midweek, true, true),
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.anyDay, false, true),
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.deliveryNowSameDay, false, false),
            new DeliverySaverFeature(this.settings.deliverySaverFeatures.bulkAndRemoteOrder, false, false),
        );

        return features;
    }

    containsB2bPlans() {
        return some(this.plansBySubscriberType, p =>
            p.Metadata &&
            p.Metadata.SubscriberType === SUBSCRIBER_TYPE.BUSINESS);
    }

    containsSeniorPlans() {
        return some(this.plansBySubscriberType, p =>
            p.Metadata &&
            p.Metadata.SubscriberType === SUBSCRIBER_TYPE.SENIOR);
    }

    filterByBySubscriberType(subscriberType) {
        if (subscriberType === SUBSCRIBER_TYPE.BUSINESS &&
            !this.settings.deliverySaver.allowB2BToSubscribe) {
            return [];
        }

        if (subscriberType === SUBSCRIBER_TYPE.SENIOR &&
            !this.settings.deliverySaver.enableSeniorPlans) {
            return [];
        }

        return filter(this.plans, p =>
            p.Metadata &&
            p.Metadata.SubscriberType === subscriberType);
    }
}

DeliverySaverPlanTypesController.$inject = ['$state', 'Settings'];

const DeliverySaverPlanTypesComponentDefinition = {
    controller: DeliverySaverPlanTypesController,
    template: require('./delivery-saver-plan-types.component.html').trim(),
    bindings: {
        disabled: '<',
        plans: '<',
        subscriberType: '<',
    },
};

module.exports = {
    DeliverySaverPlanTypesController,
    DeliverySaverPlanTypesComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/plantypes/delivery-saver-plan-types.component.js